import { isArray } from 'lodash'
import React from 'react'
import { useSelector } from 'react-redux'

export default function useRITCommunityCards(tempTableId) {
    const communityCards = useSelector((state) => state.gameTable.games[tempTableId].RITCommunityCards)

    if (!communityCards || !isArray(communityCards)) {
        return []
    }

    return communityCards
}
